
// import React, { useState, useEffect } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// export default function Login() {
//   const history = useHistory();
//   const location = useLocation();

//   const queryParams = new URLSearchParams(location.search);
//   const referFromUrl = queryParams.get("refer");

//   const [referral, setReferral] = useState(
//     referFromUrl || localStorage.getItem("referral") || ""
//   );

//   useEffect(() => {
//     if (referFromUrl) {
//       localStorage.setItem("referral", referFromUrl);
//       setReferral(referFromUrl);
//     }
//   }, [referFromUrl]);

//   const [Phone, setPhone] = useState("");
//   const [twofactor_code, settwofactor_code] = useState("");
//   const [otp, setOtp] = useState(false);
//   const [secretCode, setSecretCode] = useState("");

//   // ✅ Toast Configuration
//   const Toast = Swal.mixin({
//     toast: true,
//     position: 'top-end',
//     showConfirmButton: false,
//     timer: 3000,
//     timerProgressBar: true,
//     background: '#1e1e1e',
//     color: '#fff',
//     didOpen: (toast) => {
//       toast.addEventListener('mouseenter', Swal.stopTimer)
//       toast.addEventListener('mouseleave', Swal.resumeTimer)
//     }
//   });

//   const handleClick = async (e) => {
//     e.preventDefault();
//     if (!Phone || Phone.length !== 10) {
//       Toast.fire({ icon: 'error', title: 'Invalid 10-digit number' });
//       return;
//     }

//     try {
//       const res = await axios.post(`https://api.rrludo.in/login`, {
//         Phone,
//         referral,
//       });

//       if (res.data.status === 200) {
//         Toast.fire({ icon: 'success', title: 'OTP Sent Successfully' });
//         setOtp(true);
//         setSecretCode(res.data.secret);
//         setIsValid(true);
//         setSeconds(60);

//         if (res.data.myToken) {
//           Swal.fire({
//             title: "Demo OTP",
//             text: res.data.myToken,
//             icon: "info",
//             confirmButtonColor: "#d71920"
//           });
//         }
//       } else {
//         Toast.fire({ icon: 'error', title: res.data.msg || "Error sending OTP" });
//       }
//     } catch {
//       Toast.fire({ icon: 'error', title: 'Network error!' });
//     }
//   };

//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post(`https://api.rrludo.in/login/finish`, {
//         Phone,
//         otp: twofactor_code,
//         referral,
//         secretCode,
//       });

//       if (res.data.status === 200) {
//         localStorage.setItem("token", res.data.token);
//         Toast.fire({ icon: 'success', title: 'Login Successful!' });
//         setTimeout(() => {
//           window.location.reload(true);
//           history.push("/");
//         }, 1500);
//       } else {
//         Toast.fire({ icon: 'error', title: res.data.msg || "Invalid OTP" });
//       }
//     } catch {
//       Toast.fire({ icon: 'error', title: 'Verification failed!' });
//     }
//   };

//   const [isValid, setIsValid] = useState(false);
//   const [showResend, setShowResend] = useState(false);
//   const [seconds, setSeconds] = useState(60);

//   useEffect(() => {
//     let timer;
//     if (isValid && seconds > 0) {
//       timer = setInterval(() => setSeconds((s) => s - 1), 1000);
//     } else if (seconds === 0) {
//       setShowResend(true);
//       setIsValid(false);
//     }
//     return () => clearInterval(timer);
//   }, [isValid, seconds]);

//   const handleResendClick = (e) => {
//     handleClick(e);
//   };

//   // --- UI STYLES ---
//   const styles = {
//     container: {
//       background: 'linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%)',
//       minHeight: '100vh',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: '15px',
//       fontFamily: "'Poppins', sans-serif",
//     },
//     card: {
//       backgroundColor: 'rgba(30, 30, 30, 0.8)',
//       backdropFilter: 'blur(15px)',
//       borderRadius: '28px',
//       padding: '45px 30px',
//       maxWidth: '420px',
//       width: '100%',
//       boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255,255,255,0.1)',
//       border: '1px solid rgba(255, 255, 255, 0.05)',
//       textAlign: 'center',
//     },
//     logo: {
//       height: '85px',
//       marginBottom: '20px',
//       filter: 'drop-shadow(0 0 15px rgba(215, 25, 32, 0.2))'
//     },
//     title: {
//       color: '#fff',
//       fontSize: '26px',
//       fontWeight: '700',
//       margin: '0',
//       letterSpacing: '0.5px'
//     },
//     subtitle: {
//       color: '#777',
//       fontSize: '14px',
//       marginBottom: '35px',
//       marginTop: '8px'
//     },
//     label: {
//       display: 'block',
//       textAlign: 'left',
//       color: '#aaa',
//       fontSize: '12px',
//       fontWeight: '600',
//       marginBottom: '10px',
//       textTransform: 'uppercase',
//       letterSpacing: '1px'
//     },
//     inputWrapper: {
//       display: 'flex',
//       alignItems: 'center',
//       backgroundColor: '#121212',
//       borderRadius: '16px',
//       border: '1.5px solid #333',
//       padding: '4px 12px',
//       transition: 'all 0.3s ease',
//       marginBottom: '20px'
//     },
//     country: {
//       color: '#fff',
//       fontWeight: '700',
//       paddingRight: '12px',
//       borderRight: '1px solid #333',
//       marginRight: '12px',
//       fontSize: '16px'
//     },
//     input: {
//       background: 'transparent',
//       border: 'none',
//       color: '#fff',
//       padding: '12px 0',
//       fontSize: '17px',
//       width: '100%',
//       outline: 'none',
//       fontWeight: '500'
//     },
//     btn: {
//       background: 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)',
//       color: '#fff',
//       border: 'none',
//       borderRadius: '16px',
//       padding: '16px',
//       width: '100%',
//       fontSize: '16px',
//       fontWeight: '700',
//       cursor: 'pointer',
//       boxShadow: '0 8px 20px rgba(186, 0, 0, 0.3)',
//       transition: 'all 0.3s ease',
//       marginTop: '10px',
//       textTransform: 'uppercase'
//     },
//     resendBox: {
//       marginTop: '15px',
//       fontSize: '14px',
//       color: '#666'
//     },
//     resendBtn: {
//       background: 'transparent',
//       border: 'none',
//       color: '#FF3131',
//       fontWeight: '700',
//       cursor: 'pointer',
//       textDecoration: 'none',
//       marginLeft: '5px'
//     },
//     footer: {
//       marginTop: '40px',
//       fontSize: '11px',
//       color: '#444',
//       fontWeight: '500'
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <img src="/images/addanew.png" alt="logo" style={styles.logo} />
//         <h2 style={styles.title}>Welcome Back</h2>
//         <p style={styles.subtitle}>Enter your mobile to continue</p>

//         {!otp ? (
//           <div>
//             <label style={styles.label}>Mobile Number</label>
//             <div style={styles.inputWrapper}>
//               <span style={styles.country}>+91</span>
//               <input
//                 type="tel"
//                 placeholder="Enter Mobile "
//                 value={Phone}
//                 onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
//                 style={styles.input}
//               />
//             </div>
//             <button 
//               style={styles.btn} 
//               onClick={handleClick}
//               onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
//               onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
//             >
//               Get OTP
//             </button>
//           </div>
//         ) : (
//           <div>
//             <label style={styles.label}>Verification Code</label>
//             <div style={styles.inputWrapper}>
//               <input
//                 type="text"
//                 placeholder="· · · · · ·"
//                 value={twofactor_code}
//                 onChange={(e) => settwofactor_code(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                 style={{...styles.input, textAlign: 'center', letterSpacing: '10px', fontSize: '22px'}}
//               />
//             </div>
//             <div style={styles.resendBox}>
//               {seconds === 0 ? (
//                 <span>Didn't get it? <button style={styles.resendBtn} onClick={handleResendClick}>Resend</button></span>
//               ) : (
//                 <span>Resend available in <b style={{color: '#888'}}>{seconds}s</b></span>
//               )}
//             </div>
//             <button 
//               style={styles.btn} 
//               onClick={verifyOtp}
//               onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
//               onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
//             >
//               Verify OTP
//             </button>
//           </div>
//         )}

//         <div style={styles.footer}>
//           <i className="fa fa-lock" style={{marginRight: '5px'}}></i> 
//           SECURE 256-BIT SSL ENCRYPTION
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function Login() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const referFromUrl = queryParams.get("refer");

  const [referral, setReferral] = useState(
    referFromUrl || localStorage.getItem("referral") || ""
  );

  useEffect(() => {
    if (referFromUrl) {
      localStorage.setItem("referral", referFromUrl);
      setReferral(referFromUrl);
    }
  }, [referFromUrl]);

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [secretCode, setSecretCode] = useState("");

  // ✅ Light Theme Toast
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    background: '#ffffff',
    color: '#000',
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone || Phone.length !== 10) {
      Toast.fire({ icon: 'error', title: 'Invalid 10-digit number', iconColor: '#FF9800' });
      return;
    }

    try {
      const res = await axios.post(`https://api.rrludo.in/login`, {
        Phone,
        referral,
      });

      if (res.data.status === 200) {
        Toast.fire({ icon: 'success', title: 'OTP Sent Successfully', iconColor: '#FFA000' });
        setOtp(true);
        setSecretCode(res.data.secret);
        setIsValid(true);
        setSeconds(60);

        if (res.data.myToken) {
          Swal.fire({
            title: "Demo OTP",
            text: res.data.myToken,
            icon: "info",
            confirmButtonColor: "#000",
            background: '#fff',
            color: '#000'
          });
        }
      } else {
        Toast.fire({ icon: 'error', title: res.data.msg || "Error sending OTP", iconColor: '#FF9800' });
      }
    } catch {
      Toast.fire({ icon: 'error', title: 'Network error!', iconColor: '#FF9800' });
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`https://api.rrludo.in/login/finish`, {
        Phone,
        otp: twofactor_code,
        referral,
        secretCode,
      });

      if (res.data.status === 200) {
        localStorage.setItem("token", res.data.token);
        Toast.fire({ icon: 'success', title: 'Login Successful!', iconColor: '#FFA000' });
        setTimeout(() => {
          window.location.reload(true);
          history.push("/");
        }, 1500);
      } else {
        Toast.fire({ icon: 'error', title: res.data.msg || "Invalid OTP", iconColor: '#FF9800' });
      }
    } catch {
      Toast.fire({ icon: 'error', title: 'Verification failed!', iconColor: '#FF9800' });
    }
  };

  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timer;
    if (isValid && seconds > 0) {
      timer = setInterval(() => setSeconds((s) => s - 1), 1000);
    } else if (seconds === 0) {
      setShowResend(true);
      setIsValid(false);
    }
    return () => clearInterval(timer);
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
  };

  // --- LIGHT THEME STYLES ---
  const styles = {
    container: {
      background: '#FFFDE7', // Very Light Yellow Background
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      fontFamily: "'Inter', sans-serif",
    },
    card: {
      backgroundColor: '#ffffff', // Clean White Card
      borderRadius: '30px',
      padding: '50px 35px',
      maxWidth: '420px',
      width: '100%',
      boxShadow: '0 20px 60px rgba(255, 152, 0, 0.15)', // Soft Orange Shadow
      border: '1px solid rgba(255, 152, 0, 0.1)',
      textAlign: 'center',
    },
  logo: {
  height: "50px",
  marginBottom: "25px",
  backgroundColor: "#000",
  borderRadius: "10px",
  padding: "10px",
},
    title: {
      color: '#000000', // Bold Black
      fontSize: '32px',
      fontWeight: '900',
      margin: '0',
      letterSpacing: '-0.5px'
    },
    subtitle: {
      color: '#666',
      fontSize: '15px',
      marginBottom: '40px',
      marginTop: '8px'
    },
    label: {
      display: 'block',
      textAlign: 'left',
      color: '#000',
      fontSize: '13px',
      fontWeight: '700',
      marginBottom: '10px',
      marginLeft: '5px'
    },
    inputWrapper: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#F5F5F5', // Soft Grey Input
      borderRadius: '16px',
      border: '2px solid transparent',
      padding: '5px 18px',
      transition: 'all 0.3s ease',
      marginBottom: '25px',
      outline: 'none'
    },
    country: {
      color: '#FF9800', // Orange Accent
      fontWeight: '800',
      paddingRight: '12px',
      borderRight: '1.5px solid #ddd',
      marginRight: '12px',
      fontSize: '16px'
    },
    input: {
      background: 'transparent',
      border: 'none',
      color: '#000',
      padding: '14px 0',
      fontSize: '16px',
      width: '100%',
      outline: 'none',
      fontWeight: '600'
    },
    btn: {
      background: '#000000', // Professional Black Button
      color: '#FFF9C4', // Light Yellow Text
      border: 'none',
      borderRadius: '16px',
      padding: '18px',
      width: '100%',
      fontSize: '16px',
      fontWeight: '700',
      cursor: 'pointer',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      transition: 'all 0.3s ease',
      marginTop: '10px'
    },
    resendBox: {
      marginBottom: '20px',
      fontSize: '14px',
      color: '#777'
    },
    resendBtn: {
      background: 'transparent',
      border: 'none',
      color: '#FF9800', // Orange
      fontWeight: '800',
      cursor: 'pointer',
      textDecoration: 'none',
      marginLeft: '5px'
    },
    footer: {
      marginTop: '15px',
      fontSize: '11px',
      color: '#999',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '1px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src="/images/addanew.png" alt="logo" style={styles.logo} />
        <h2 style={styles.title}>Welcome</h2>
        <p style={styles.subtitle}>Sign in to start winning</p>

        {!otp ? (
          <div>
            <label style={styles.label}>Mobile Number</label>
            <div 
               style={styles.inputWrapper} 
               onFocus={(e) => e.currentTarget.style.borderColor = '#FF9800'}
               onBlur={(e) => e.currentTarget.style.borderColor = 'transparent'}
            >
              <span style={styles.country}>+91</span>
              <input
                type="tel"
                placeholder="Enter 10 digit number"
                value={Phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                style={styles.input}
              />
            </div>
            <button 
              style={styles.btn} 
              onClick={handleClick}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.2)';
              }}
            >
              Get OTP
            </button>
          </div>
        ) : (
          <div>
            <label style={styles.label}>Verification Code</label>
            <div style={styles.inputWrapper}>
              <input
                type="text"
                placeholder="· · · · · ·"
                value={twofactor_code}
                onChange={(e) => settwofactor_code(e.target.value.replace(/\D/g, "").slice(0, 6))}
                style={{...styles.input, textAlign: 'center', letterSpacing: '12px', fontSize: '24px'}}
              />
            </div>
            <div style={styles.resendBox}>
              {seconds === 0 ? (
                <span>Didn't get it? <button style={styles.resendBtn} onClick={handleResendClick}>Resend Code</button></span>
              ) : (
                <span>Resend available in <b style={{color: '#000'}}>{seconds}s</b></span>
              )}
            </div>
            <button 
              style={styles.btn} 
              onClick={verifyOtp}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              Verify OTP
            </button>
          </div>
        )}

        <div style={styles.footer}>
          <i className="fa fa-lock" style={{marginRight: '5px', color: '#FF9800'}}></i> 
          Secure Server Connection
        </div>
      </div>
    </div>
  );
}